(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["novalux-contact-receipt"] && !Shopify.designMode) return;
  try {
    const initNovaluxReceipt = () => {
    const key = 'novalux_contact_attempt_v1';
    const success = document.querySelector('[data-nl-contact-success]');
    const unconfirmed = document.querySelector('[data-nl-contact-unconfirmed]');
    const form = document.getElementById('NLContactForm');
    const project = document.getElementById('NLContactProject');
    const categories = ['building', 'industry', 'energy', 'appliances', 'general'];
    let attempt = null;
    let recent = false;
    try {
      attempt = JSON.parse(sessionStorage.getItem(key) || 'null');
      const age = Date.now() - Number(attempt?.at);
      recent = attempt?.form === 'NLContactForm' && age >= 0 && age < 15 * 60 * 1000;
    } catch {}
    if (recent && form?.querySelector('.nl-form-message--error') && project && categories.includes(attempt.projectArea)) {
      project.value = attempt.projectArea;
    }
    if (success) {
      try {
        sessionStorage.removeItem(key);
      } catch {}
      if (recent) {
        if (unconfirmed) unconfirmed.hidden = true;
        success.hidden = false;
        const message = document.getElementById('NLContactSuccess');
        message?.focus({ preventScroll: true });
        message?.scrollIntoView({ block: 'center', behavior: 'instant' });
      }
    }
    if (form) {
      form.addEventListener('submit', () => {
        if (!form.checkValidity()) return;
        const projectArea = categories.includes(project?.value) ? project.value : '';
        try { sessionStorage.setItem(key, JSON.stringify({ form: 'NLContactForm', at: Date.now(), projectArea })); } catch {}
      });
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initNovaluxReceipt, { once: true });
  else initNovaluxReceipt();
  } catch(e) { console.error(e); }
})();

})();
